import styled from 'styled-components';
import { testableStyledComponentConfig } from '@24i/nxg-sdk-gluons';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { Breakpoint } from '@24i/nxg-sdk-smartott/src/utils/styles/constants';
import { getClassificationsStyles, } from '@24i/nxg-sdk-smartott/src/components/Classifications';
const logoSize = '56px';
export const MetadataContainer = styled.div `
    display: flex;
    flex: 1;
`;
export const MetadataContent = styled.div `
    display: flex;
    height: ${logoSize};
    flex-direction: row;
    align-items: flex-start;
    padding-left: 6px;
    font-family: 'HK Grotesk Bold';
    flex: 1;
`;
export const MetadataTextContent = styled.div `
    display: flex;
    flex-direction: column;
    padding-left: 12px;
    justify-content: center;
    align-items: flex-start;
    height: 100%;
    flex: 1;
`;
export const ChannelContainer = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 12px;
`;
export const ChannelNumber = styled.span `
    ${({ theme }) => getFont(theme, 'h4')}
    color: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textSecondary; }};
    text-align: right;
    margin-right: 12px;
`;
export const ChannelLogo = styled.img `
    width: ${logoSize};
    height: ${logoSize};
    margin-left: 0;
    object-fit: contain;
`;
export const FlexRow = styled.div.withConfig(testableStyledComponentConfig) `
    display: flex;
    flex-direction: row;
    align-items: center;
`;
export const Title = styled.span `
    ${({ theme }) => getFont(theme, 'h3', true)}
    color: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textSecondary; }};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;
export const SubTitle = styled.span `
    ${({ theme }) => getFont(theme, 'h5', true)}
    color: ${({ theme }) => { var _a; return (_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textSecondary; }};
    opacity: 0.8;
    align-items: flex-start;
    align-self: center;
`;
export const SubTitle2 = styled(SubTitle) `
    ${({ theme }) => getFont(theme, 'h6', true)}
`;
export const SubTitleRowsContainer = styled.div `
    position: relative;
    height: 0;
    width: 100%;
`;
export const SubTitleRows = styled.div `
    position: absolute;
    top: 3px;
    left: 0;
`;
export const getMetadataClassificationsStyles = (theme) => {
    const classificationsStyles = getClassificationsStyles(theme);
    return Object.assign(Object.assign({}, classificationsStyles), { separator: Object.assign(Object.assign({ color: `${theme.color.textSecondary}` }, getFont(theme, 'h5', true)), { marginRight: 2 }), imageView: {
            width: 24,
            height: 20,
            [`@media (max-width: ${Breakpoint.XL}px)`]: {
                width: 20,
                height: 16,
            },
        }, image: {
            width: 20,
            height: 20,
            [`@media (max-width: ${Breakpoint.XL}px)`]: {
                width: 16,
                height: 16,
            },
        } });
};
//# sourceMappingURL=index.js.map